import { render, staticRenderFns } from "./ApproveConfirmationModal.vue?vue&type=template&id=21875e92&scoped=true&"
import script from "./ApproveConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./ApproveConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21875e92",
  null
  
)

export default component.exports